import CommonBetContent from './_common-bet-content.js'
import DefaultBetContent from './_default-bet-content.js'
import MatchAccaBetContent from './_match-acca-bet-content.js'
import BetslipBet from './_betslip-bet.js'
import ConfigurablePane from './_configurable-pane.js'
import FlexItemBase from './_flex-item-base.js'
import PotentialReturns from './_potential-returns.js'
import FormattedLabelWithPrice from './_formatted-label-with-price.js'
import OddsBoostBanner from './_odds-boost-banner.js'

export default {
  name: 'SingleBet',
  values: {
    betContent: {
      base: {
        configSet: CommonBetContent,
        configValues: {},
      },
      default: {
        configSet: DefaultBetContent,
        configValues: {},
      },
      matchAcca: {
        configSet: MatchAccaBetContent,
        configValues: {},
      },
    },
    betslipBet: {
      configSet: BetslipBet,
      configValues: {},
    },
    betBuilderContainer: {
      borderRadius: '4px',
      position: 'relative',
      padding: '8px',
      margin: '8px',
      $mixin: [
        {
          configSet: ConfigurablePane,
        },
        {
          configSet: FlexItemBase,
        },
      ],
    },
    potentialReturns: {
      configSet: PotentialReturns,
      configValues: {},
    },
    potentialTax: {
      configSet: FormattedLabelWithPrice,
      configValues: {
        container: {
          style: {
            padding: '4px 0 0 0',
            justifyContent: 'flex-end',
          },
        },
        label: {
          container: {
            flexGrow: 0,
            padding: '0 4px 0 0',
          },
        },
      },
    },
    oddsBoostBanner: {
      configSet: OddsBoostBanner,
      configValues: {},
    },
  },
  meta: {
    extendable: false,
  },
}
